import React from 'react';
import styled from 'styled-components';
import { ReactComponent as RecordIcon } from '../../assets/icons/action/record.svg';

interface TimerIconProps {
  $isRecording: boolean;
}

const TimerButton = styled.div`
  background: #FFFFFF;
  color: #1E194B;
  border: none;
  outline: none;
  box-shadow: none;
  border-radius: 8px;
  padding: 8px 11px;
  height: 32px;
  width: 82px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 480px) {
    min-width: 80px;
  }
`;

const TimerIcon = styled(RecordIcon)<TimerIconProps>`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  color: ${({ $isRecording }) => ($isRecording ? '#EB0037' : 'currentColor')};
  fill: none;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const TimerText = styled.span`
  font-size: 14px;
  font-weight: 600;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

interface RecordingStatusUIProps {
  formattedTime: string;
  isRecording: boolean;
}

const RecordingStatusUI: React.FC<RecordingStatusUIProps> = ({
  formattedTime,
  isRecording,
}) => (
  <TimerButton id="timer-button">
    <TimerIcon id="timer-icon" $isRecording={isRecording} />
    <TimerText id="timer-text">{formattedTime}</TimerText>
  </TimerButton>
);

export default RecordingStatusUI;
